import { CREATEPOLICY_SUCCESS, CREATEPOLICY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const createPolicyReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATEPOLICY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CREATEPOLICY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createPolicyReducer;
